import { takeEvery } from 'redux-saga'
import { take, call, fork, race } from 'redux-saga/effects'
import { LOCATION_CHANGE } from 'react-router-redux'

import actions from 'actions'
import {
  acknowledgePerformance,
  draftDealsCancelSaga,
  loadPerformance,
  loadPerformanceTicketDetails,
  pollPerformanceTicketDetails,
  dealsBatchUpdateSaga,
  draftDealSuccessSaga,
} from './performance-sagas'

export function* watchPerformancePage() {
  while (true) {
    const { performanceId } = yield take(actions.PERFORMANCE_LOAD_PAGE)
    yield fork(loadPerformance, performanceId)
    yield fork(loadPerformanceTicketDetails, performanceId)
  }
}

export function* watchPollPerformancePage() {
  while (true) {
    const { performanceId } = yield take(actions.PERFORMANCE_LOAD_PAGE)
    let polling = true
    while (polling) {
      // use race to cancel polling on LOCATION_CHANGE
      const { cancel } = yield race({
        response: call(pollPerformanceTicketDetails, performanceId),
        cancel: take(LOCATION_CHANGE),
      })
      polling = !cancel
    }
  }
}

export function* watchAcknowledgePerformance() {
  while (true) {
    const { performanceId, print } = yield take(actions.PERFORMANCE_ACKNOWLEDGE)
    yield fork(acknowledgePerformance, performanceId, print)
  }
}

export function* watchDraftDealsSave() {
  yield* takeEvery(actions.DRAFT_DEALS_SAVE, dealsBatchUpdateSaga)
}

export function* watchEntitiesDealsSuccess() {
  yield* takeEvery(actions.ENTITIES_DEALS.SUCCESS, draftDealSuccessSaga)
}

export function* watchDraftDealsCancel() {
  yield* takeEvery(actions.DRAFT_DEALS_CANCEL, draftDealsCancelSaga)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/performance/performance-watchers.js
 **/